export const CheckClientHeader = 'ancon go virtual pos' as const

/**
 * API version of the check online payment endpoints that run the payment in
 * a background worker, and of their shared status endpoint
 */
export const CheckOnlinePaymentAPIVersion = 2.1

/**
 * How long to poll a check online payment worker. The worker only runs the
 * Adyen request and the check closing, while the guest waits for the result
 */
export const CheckOnlinePaymentWorkerLifetimeMillis = 2 * 60 * 1000
